import { USUARIO } from "@pcgerente-node/pcg-comun/dist/DTOs";
import { BaseViewModelClass } from "../Utils/BaseViewModel";
import { RolesUsuarios } from "../components/useAuth/useAuth";
import { limpiarAuthSlice } from "../redux/actions/actionAuth";

export class USUARIOviewModel extends BaseViewModelClass<USUARIO> {
    constructor(){
        super(new USUARIO())
    }


    //Auth
    public autenticado: boolean = false
    public requiereCambiarContrasenia: boolean = false
    public rolUsuario: RolesUsuarios = "" as RolesUsuarios
    public error?: string  

    
    
    public limpiarUsuarioVM(dispatch: (props: any) => any){
        dispatch(limpiarAuthSlice())
    }
}